$(function(){
    $('.menu').on('click',function(){
        $('header').toggleClass('on')
        return false;
    })

    $('.depth-1').on('click',function(){
        $(this).next('.depth-2').toggleClass('on')
    })
    $(window).scroll(function(){
        var $top = $(this).scrollTop();
        if($top > 10){
            $('.top').addClass('on')
        }else{
            $('.top').removeClass('on')
        }
    })
    $('.top').on('click',function(){
        $('html,body').animate({scrollTop:0},500)
        return false;
    })
     // 팝업 
     $('#pw_reset').click(function() {
		$('.popup').fadeIn();
		$('.popup_mask').fadeIn();
	});
	$('.close, cancel').click(function() {
		$('.popup').fadeOut();
		$('.popup_mask').fadeOut();
	});
})


// WEBPACK FOOTER //
// ./src/assets/js/common.js